import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { mapDefaultValues } from "protocol-setup/helpers";
import { yupResolver } from "@hookform/resolvers/yup";
import { createPsrFormSchema } from "./PSRFormSchema";
import { PSRFormCore, PSRSelector } from "./PSRForm";

const defaultValues = {
  psrName: "",
  psrVersionDt: "",
  psrType: "",
  psrRequiredByDt: "",
  psrNumOfPersons: "",
  isEvaluationByGroup: "",
  sourceSubmittedBy: "",
  ctsuProcessingInstructions: "",
  psrComments: "",
  psrContactName: "",
  psrContactPhoneNum: "",
  psrContactEmailAddress: "",
  psrDistributionList: "",
  createdBy: "",
  createdDt: "",
  modifiedBy: "",
  modifiedDt: ""
};

export const CopyPSR = ({ psrList, onClose, onAddPSR, today, setModalTitle, isOldPsr}) => {
  const [selectedPSR, setSelectedPSR] = useState("");
  const [editMode, setEditMode] = useState(false);
  const {
    control,
    handleSubmit,
    getValues,
    reset,
    trigger,
    formState: { isValid, isDirty }
  } = useForm({
    resolver: yupResolver(createPsrFormSchema(!isOldPsr)), // true for new PSR
    defaultValues,
    mode: "onBlur"
  });
  const onSubmit = (data) => {
    onAddPSR(data);
    setEditMode(false);
    onClose();
  };
  const handleCancel = () => {
    if (onClose) onClose();
    setEditMode(false);
  };
  const handleSetEditMode = (mode) => {
    setEditMode(mode);
    if (mode) {
      if (selectedPSR) {
        const currentValues = getValues();
        reset(
          {
            ...currentValues,
            psrVersionDt: "",
            psrType: "",
            psrRequiredByDt: "",
            isEvaluationByGroup: "",
            sourceSubmittedBy: ""
          },
          {
            keepDirty: false,
            keepErrors: false,
            keepIsSubmitted: false,
            keepTouched: false,
            keepIsValid: false,
            keepSubmitCount: false
          }
        );
        trigger();
      }
      setModalTitle("Edit PSR Requirement");
    }
  };
  const patchFields = (fieldsToUpdate) => {
    const newValues = { ...fieldsToUpdate };
    reset(newValues, {
      keepDirty: false,
      keepErrors: false,
      keepIsSubmitted: false,
      keepTouched: false,
      keepIsValid: false,
      keepSubmitCount: false
    });
    trigger();
  };
  const handlePSRSelect = (psrId, psrData) => {
    setSelectedPSR(psrId);
    setEditMode(false);
    if (psrData) {
      const fieldMapping = {
        psrVersionDt: psrData?.forVersionDate || "",
        psrRequiredByDt: psrData?.requiredByDate || "",
        psrName: psrData?.description || "",
        psrNumOfPersons: psrData?.numPersonRqdFulfillPsr || psrData?.psrNumOfPersons || "",
        ctsuProcessingInstructions: psrData?.ctsuGeneralInstructions || "",
        isEvaluationByGroup: psrData?.isEvalByGroup !== undefined ? psrData?.isEvalByGroup : "",
        psrContactName: psrData?.contactName || "",
        psrContactPhoneNum: psrData?.contactPhone || "",
        psrContactEmailAddress: psrData?.contactEmail || "",
        psrDistributionList: psrData?.distributionEmail || "",
        psrComments: psrData?.comments || "",
        sourceSubmittedBy: psrData?.source,
        modifiedDt: psrData?.modifiedDate,
        createdDt: psrData?.createdDate
      };

      const fieldValues = mapDefaultValues(psrData, defaultValues, fieldMapping);
      patchFields(fieldValues);
    } else {
      reset(defaultValues);
    }
  };
  return (
    <div className="p-6">
      <PSRSelector
        psrList={psrList}
        selectedPSR={selectedPSR}
        onPSRSelect={handlePSRSelect}
        setSelectedPSR={setSelectedPSR}
      />
      <PSRFormCore
        key={selectedPSR}
        selectedPSRChangeType="copy"
        editMode={editMode}
        control={control}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        handleCancel={handleCancel}
        isValid={isValid}
        isDirty={isDirty}
        selectedPSR={selectedPSR}
        today={today}
        setEditMode={handleSetEditMode}
        trigger={trigger}
        cardStyle
      />
    </div>
  );
};

export const NewPSR = ({ onClose, onAddPSR, today }) => {
  const [editMode, setEditMode] = useState(true);
  const {
    control,
    handleSubmit,
    trigger,
    formState: { isValid, isDirty }
  } = useForm({
    resolver: yupResolver(createPsrFormSchema(true)), // true for new PSR
    defaultValues,
    mode: "onChange"
  });
  const onSubmit = (data) => {
    onAddPSR(data);
    setEditMode(false);
    onClose();
  };
  const handleCancel = () => {
    if (onClose) onClose();
    setEditMode(false);
  };
  return (
    <div className="p-6">
      <PSRFormCore
        selectedPSRChangeType="newPSR"
        editMode={editMode}
        control={control}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        handleCancel={handleCancel}
        isValid={isValid}
        isDirty={isDirty}
        selectedPSR="new"
        today={today}
        setEditMode={setEditMode}
        trigger={trigger}
      />
    </div>
  );
};
const PSRForm = ({ selectedPSRChangeType, psrList, onClose, onAddPSR, today, setModalTitle, FormValues }) => {
  if (selectedPSRChangeType === "copy") {
    return (
      <CopyPSR psrList={psrList} onClose={onClose} onAddPSR={onAddPSR} today={today} setModalTitle={setModalTitle} isOldPsr />
    );
  }
  return <NewPSR onClose={onClose} onAddPSR={onAddPSR} today={today} />;
};
export default PSRForm;
